import { createFileRoute } from "@tanstack/react-router";
import { LegalPage } from "@/components/legal-page";

export const Route = createFileRoute("/about")({
  head: () => ({
    meta: [
      { title: "About Pyng" },
      { name: "description", content: "Pyng is a private space for the relationships that matter." },
      { property: "og:title", content: "About Pyng" },
      { property: "og:description", content: "Pyng is a private space for the relationships that matter." },
    ],
  }),
  component: AboutPage,
});

function AboutPage() {
  return (
    <LegalPage eyebrow="Our story" title="About Pyng">
      <p>Pyng was built for a simple feeling: the quiet regret of losing touch with someone who mattered. The mentor who shaped your career. The friend who showed up when nothing else made sense. The collaborator you keep meaning to call.</p>

      <h2>What Pyng is</h2>
      <p>A calm, intelligent companion for your relationships. It remembers what you tell it, surfaces the right person at the right moment, and helps you reach out in your own voice — not a templated one.</p>

      <h2>What Pyng is not</h2>
      <ul>
        <li>Not a CRM. We're not here to help you "manage leads."</li>
        <li>Not a social network. There's no feed, no likes, no public profile.</li>
        <li>Not a productivity grind. The point is presence, not performance.</li>
      </ul>

      <h2>Why private-first</h2>
      <p>Your relationships are the most personal data you have. Pyng treats them that way. Your memories aren't training data. Your contacts aren't a product. Read more in our <a href="/privacy">Privacy Policy</a>.</p>

      <h2>Who's behind it</h2>
      <p>A small, distributed team that cares more about craft than scale. We're in private beta because we'd rather earn your trust slowly than grow loudly.</p>
    </LegalPage>
  );
}
